var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center flex-column"},[_c('property-form',{attrs:{"value":_vm.value ||
      Object.keys(_vm.fields).reduce((a, v) => {
        a[v] = _vm.fields[v].default ?? '';
        return a;
      }, {}),"fields":_vm.fields},on:{"input":_vm.createCourse}}),_c('error-message-wrapper',{ref:"error_wrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }